// src/features/system/orchestrator/api/outcomeEventsApi.ts
import { bff } from '@/lib/http/bff';

export interface StepOutcomeEvent {
  outcome_id: number;
  run_id: number;
  id_scope?: number | null;
  id_scope_father?: number | null;
  tenant_id: number;
  workflow_key: string;
  device_id?: string | null;
  step_key: string;
  handler_key: string;
  worker_key?: string | null;
  handler_key_base?: string | null;
  handler_namespace?: string | null;
  id_category: number;
  id_type: number;
  outcome_key: string;
  outcome_value_kind: string;
  value: any;
  created_at: string;
}

// Compact response for production FE use: minimal fields + opaque cursor token.
export interface StepOutcomeEventCompact {
  tenant_id: number;
  workflow_key: string;
  step_key: string;
  handler_key: string;
  device_id?: string | null;
  worker_key?: string | null;
  handler_key_base?: string | null;
  handler_namespace?: string | null;
  outcome_key: string;
  value: any;
  created_at: string;
}

export interface ListStepOutcomeEventsParams {
  // If omitted, backend returns a "latest snapshot" (no time window).
  from?: string; // RFC3339/ISO
  to?: string;   // RFC3339/ISO
  as_of?: string; // optional snapshot frontier
  include_history?: boolean; // requires from/to
  tenant_id?: number;
  workflow_key?: string;
  handler_key?: string;
  worker_key?: string;
  handler_key_base?: string;
  handler_namespace?: string;
  id_scope?: number;
  id_scope_father?: number;
  outcome_key?: string;
  device_id?: string;
  id_category?: number;
  id_type?: number;
  limit?: number;
  cursor_created_at?: string;
  cursor_outcome_id?: number;
}

export interface ListStepOutcomeEventsCompactParams {
  // Same filter surface as /outcomes/steps, but pagination uses `cursor`.
  from?: string;
  to?: string;
  as_of?: string;
  include_history?: boolean;
  tenant_id?: number;
  workflow_key?: string;
  handler_key?: string;
  worker_key?: string;
  handler_key_base?: string;
  handler_namespace?: string;
  id_scope?: number;
  id_scope_father?: number;
  outcome_key?: string;
  device_id?: string;
  id_category?: number;
  id_type?: number;
  limit?: number;

  // Opaque cursor token returned by the compact endpoint.
  cursor?: string;

  // Optional back-compat (if needed):
  cursor_created_at?: string;
  cursor_outcome_id?: number;
}

export interface ListStepOutcomeEventsResponse {
  from?: string;
  to?: string;
  as_of?: string;
  include_history?: boolean;
  items: StepOutcomeEvent[];
  next_cursor?: {
    created_at: string;
    outcome_id: number;
  } | null;
}

export interface ListStepOutcomeEventsCompactResponse {
  from?: string;
  to?: string;
  as_of?: string;
  include_history?: boolean;
  items: StepOutcomeEventCompact[];
  next_cursor?: string | null;
}

export function fetchOutcomeStepEventsApi(
  params: ListStepOutcomeEventsParams
): Promise<ListStepOutcomeEventsResponse> {
  return bff.get<ListStepOutcomeEventsResponse>('/orchestrator/outcomes/steps', params as any);
}

export function fetchOutcomeStepEventsCompactApi(
  params: ListStepOutcomeEventsCompactParams
): Promise<ListStepOutcomeEventsCompactResponse> {
  return bff.get<ListStepOutcomeEventsCompactResponse>('/orchestrator/outcomes/steps/compact', params as any);
}
